import { render, staticRenderFns } from "./PlayerListings.vue?vue&type=template&id=08635a8b"
import script from "./PlayerListings.vue?vue&type=script&lang=js"
export * from "./PlayerListings.vue?vue&type=script&lang=js"
import style0 from "./PlayerListings.vue?vue&type=style&index=0&id=08635a8b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports